import { useQuery } from 'react-query'
import { AxiosResponse } from 'axios'

//constants
import QueryKeys from 'constants/queryKeys'
//services
import { getGeoData } from 'services/geoDataService'
//types
import { IpGeoLocationResponse } from 'types'
//utils
import { captureEvent } from '@sentry/react'
import { ERRORS } from '../constants'

// 30 minutes in milliseconds
const CACHE_TIME = 30 * 60 * 1000

const useGeoDataQuery = () => {
  const { data, isLoading, refetch, isFetching, dataUpdatedAt } = useQuery<
    AxiosResponse<IpGeoLocationResponse, Error>
  >(QueryKeys.GET_GEO_DATA, getGeoData, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    // Keep the data fresh for 30 minutes
    staleTime: CACHE_TIME,
    // Keep the data cached for 30 minutes
    cacheTime: CACHE_TIME,
    // Don't refetch automatically when the query is stale
    refetchOnMount: false,
    onError: (error) => {
      captureEvent({
        message: ERRORS.GEO_LOCATION_RETRIEVAL_SERVICE_ERROR,
        level: 'error',
        extra: { err: error },
      })
      console.error('Geolocation error', error)
    },
  })

  return {
    geoData: data?.data,
    isLoadingGeoData: isLoading,
    refetchGeoData: refetch,
  }
}

export default useGeoDataQuery
